import { INavigation } from '@/store/modules/devices/types';

export const initNavigationData: INavigation = {
  start: 0,
  devicesPerPage: 20,
  direction: 'forward',
  isLastDevicePage: false
};

export default initNavigationData;
